import 'babel-polyfill';
import Vue from 'vue';

import Vuetify, {VApp, VBtn, VContent, VForm, VLayout} from 'vuetify/lib';
import App from './App.vue';
import router from './router';
import VeeValidate from 'vee-validate';
import store from './store';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';
import './style.scss';
import {messages} from './validation-messages';

Vue.config.productionTip = false;
Vue.use(VeeValidate, {
  validity: true,
});
VeeValidate.Validator.localize(messages);

Vue.use(Vuetify, {
  components: {
    VApp,
    VLayout,
    VContent,
    VForm,
    VBtn,
  },
});
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
